import { fetchUserForSearch, getAllSavedItinerary } from "../../Services/user_question_history";

// Chips show "#id name (email)", like the To field of a mail client.
const toOption = (u) => ({ value: u.value, label: `#${u.value} ${u.label} (${u.email})`, name: u.label, email: u.email });

// Users: name / email / id search, and email paste (comma, space or new-line separated).
export const fetchUsers = async (page, search) => {
  const res = (await fetchUserForSearch(page, search)) || [];
  return res.map((u) => toOption(u));
};

export const pasteUsers = async (emailsCsv) => {
  const res = await fetchUserForSearch(0, "", "copy_paste", emailsCsv);
  return {
    found: (res?.avl_user || []).map((u) => toOption(u)),
    notFound: res?.not_avail || [],
  };
};

const cityOf = (it) => ((it?.to_location || "").split(",")[0] || "").trim();

// Itineraries: headline / location / id search across all users.
export const fetchItineraries = async (page, search) => {
  const res = await getAllSavedItinerary({ skip: page * 10, limit: 10, search });
  return (res?.data || []).map((it) => ({
    value: it.id,
    label: cityOf(it) || it.itineary_headline_text,
    headline: it.itineary_headline_text,
    owner: it.user_name,
  }));
};
